import { Language } from '../types';

export const languages: Language[] = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '中文 (Chinese)' },
  { code: 'hi', name: 'हिन्दी (Hindi)' },
  { code: 'es', name: 'Español (Spanish)' },
  { code: 'ar', name: 'العربية (Arabic)' },
  { code: 'bn', name: 'বাংলা (Bengali)' },
  { code: 'pt', name: 'Português (Portuguese)' },
  { code: 'ru', name: 'Русский (Russian)' },
  { code: 'ja', name: '日本語 (Japanese)' },
  { code: 'pa', name: 'ਪੰਜਾਬੀ (Punjabi)' },
  { code: 'de', name: 'Deutsch (German)' },
  { code: 'jv', name: 'Basa Jawa (Javanese)' },
  { code: 'ko', name: '한국어 (Korean)' },
  { code: 'fr', name: 'Français (French)' },
  { code: 'te', name: 'తెలుగు (Telugu)' },
  { code: 'mr', name: 'मराठी (Marathi)' },
  { code: 'tr', name: 'Türkçe (Turkish)' },
  { code: 'ta', name: 'தமிழ் (Tamil)' },
  { code: 'vi', name: 'Tiếng Việt (Vietnamese)' },
  { code: 'ur', name: 'اردو (Urdu)' },
  { code: 'it', name: 'Italiano (Italian)' },
  { code: 'th', name: 'ไทย (Thai)' },
  { code: 'gu', name: 'ગુજરાતી (Gujarati)' },
  { code: 'pl', name: 'Polski (Polish)' },
  { code: 'uk', name: 'Українська (Ukrainian)' },
  { code: 'fa', name: 'فارسی (Persian)' },
  { code: 'ro', name: 'Română (Romanian)' },
  { code: 'nl', name: 'Nederlands (Dutch)' },
  { code: 'el', name: 'Ελληνικά (Greek)' },
  { code: 'sw', name: 'Kiswahili (Swahili)' },
];